let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("ey3BD")).then(() => parcelRequire('4bKvg'));